import type { ReactNode } from "react";
import { SiteHeader } from "./SiteHeader";
import { SiteFooter } from "./SiteFooter";
import { FloatingActions } from "./FloatingActions";

export function PageShell({ children }: { children: ReactNode }) {
  return (
    <div className="flex min-h-dvh flex-col bg-background">
      <SiteHeader />
      <main className="flex-1">{children}</main>
      <SiteFooter />
      <FloatingActions />
    </div>
  );
}

export function PageHero({ eyebrow, title, subtitle }: { eyebrow?: string; title: string; subtitle?: string }) {
  return (
    <section className="border-b border-border bg-background">
      <div className="container-page py-14 md:py-20 fade-in-up">
        {eyebrow && <div className="text-xs font-semibold uppercase tracking-[0.2em] text-primary/70">{eyebrow}</div>}
        <h1 className="mt-3 font-display text-3xl md:text-5xl font-bold text-primary max-w-3xl">{title}</h1>
        {subtitle && <p className="mt-4 max-w-2xl text-foreground/70 md:text-lg">{subtitle}</p>}
      </div>
    </section>
  );
}
